import axios from 'axios'
import { host } from '../../helper/config'

const PLUGINS_NAME = 'admin-worker-queue'

const headers = (token) => ({
  'Access-Control-Allow-Origin': '*',
  'Content-Type': 'application/json',
  'Authorization': token
})

export const fetchWorkerQueues = async (token) => {
  const response = await axios.get(`${host}/${PLUGINS_NAME}/queues`, {
    headers: headers(token)
  })
  if (response && response.status === 200) {
    return response.data
  }
  return null
}

export const fetchQueueJobs = async (token, { queue, states, start, end, asc }) => {
  const params = new URLSearchParams()
  params.set('queue', queue)
  if (states) {
    params.set('states', states)
  }
  if (start != null && start !== '') {
    params.set('start', String(start))
  }
  if (end != null && end !== '') {
    params.set('end', String(end))
  }
  if (asc) {
    params.set('asc', '1')
  }
  const response = await axios.get(`${host}/${PLUGINS_NAME}/jobs?${params.toString()}`, {
    headers: headers(token)
  })
  if (response && response.status === 200) {
    return response.data
  }
  return null
}

export const releaseQueueJob = async (token, queue, jobId) => {
  const response = await axios.post(
    `${host}/${PLUGINS_NAME}/jobs/release`,
    { queue, jobId },
    { headers: headers(token) }
  )
  if (response && response.status === 200) {
    return response.data
  }
  return null
}

/**
 * Remove completed and/or failed jobs from a queue (BullMQ clean).
 * @param {{ completed?: boolean, failed?: boolean }} types — at least one must be true
 */
export const cleanQueueJobs = async (token, queue, { completed = false, failed = false }) => {
  const response = await axios.post(
    `${host}/${PLUGINS_NAME}/jobs/clean`,
    { queue, completed, failed },
    { headers: headers(token) }
  )
  if (response && response.status === 200) {
    return response.data
  }
  return null
}
